import {Concept} from 'types';
import type {TypedSchema} from 'schemaDefinition/types';
import {Separator} from 'schemaDefinition/types';
import type {AgentEvent} from 'services/agent/types';
import {agentBAREParts} from './parts';

export const agentEventSchemas: TypedSchema<AgentEvent> = {
  name: 'event',
  key: 'event',
  parts: [
    {...Separator('card', 'line'), titleKey: 'nameVariants'},
    {
      type: 'nameVariant',
      agentType: Concept.event,
      name: 'nameVariants',
      cardinality: 'multiple',
      required: true,
    },
    {
      key: 'oldDescription',
      type: 'text',
      name: 'description',
      readonly: true,
    },
    Separator('card', 'line'),
    [...agentBAREParts],
    {
      type: 'text',
      name: 'id',
      readonly: true,
    },
    ...([
      {
        type: 'linkedLiterary',
        name: 'links',
        key: 'links',
        cardinality: 'multiple',
        //linkPropRequired: 'should',
        roleCodelistId: 'agent.linkedRole',
      },
    ] as TypedSchema<AgentEvent>['parts']),
    Separator('line', 'line'),
    {
      type: 'text',
      name: 'place',
    },
    [
      {
        type: 'yearOrDate',
        name: 'from',
        validation: [
          {
            max: {$ref: ':to'},
            messageKey: 'birthBeforeDeath',
          },
        ],
      },
      {
        type: 'yearOrDate',
        name: 'to',
        validation: {
          min: {$ref: ':from'},
          messageKey: 'deathAfterBirth',
        },
      },
    ],
    {
      type: 'textarea',
      name: 'externalComments',
      maxLength: 5000,
    },
    {...Separator('card', 'line'), titleKey: 'internalComments'},
    {
      type: 'textarea',
      name: 'internalComments',
      maxLength: 5000,
    },
  ],
};
